var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPxTecnologia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.8 274.2",
    style: {
      enableBackground: "new 0 0 479.8 274.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 9.6,
    className: "st0",
    width: 61.1,
    height: 257.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,7.7c0,0,33.6,34.1,33,85.7c-0.3,23.7-0.7,51.9-27.3,80.7c0,0,89.9,10,98.3-83.2 C207.7,2.7,107.4,7.7,107.4,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.4,194.4l-59.5,72.8h97.6c-8.5-9.1-19.5-23-28-42.1C283.3,213.7,280.2,203.2,278.4,194.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212.7,11.9 290.1,11.9 471.6,266.2 394.6,266.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.2,80.4l59.5-72.8h-97.6c8.5,9.1,19.5,23,28,42.1C410.3,61,413.4,71.6,415.2,80.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxTecnologia);
export default __webpack_public_path__ + "static/media/px-tecnologia.4817adae0320b6444dbc951dd231f4de.svg";
export { ForwardRef as ReactComponent };